import { onlineApplicationsDefaultConfiguration, normalizeVisibleAOPColumns } from "@/src/constants/applicationOnlineConsts";
import { admissionDatabaseDefaultConfiguration, normalizeVisibleAODColumns } from "@/src/constants/AdmissionOffice/admissionOfficeDatabaseConsts";
import { normalizeVisibleTOPColumns, tasksDefaultConfiguration } from "@/src/constants/tasksTableColumns";
import { normalizeVisibleOAPColumns, officeAccountingDefaultConfiguration } from "@/src/constants/officeAccountingTableConfig";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { sideBarMenuAllOptions } from "@/src/constants/sidebar";
import { getUserConfigFromStorage } from "@/src/utils/userConfigStorage";
import { IUserOptionsConfig } from "@/src/types/userOptions";

const userConfig = getUserConfigFromStorage();

const initialState: IUserOptionsConfig = {
  AOPConfig: {
    AOPTable: normalizeVisibleAOPColumns(userConfig?.AOPConfig?.AOPTable ?? onlineApplicationsDefaultConfiguration),
    AOPFixed: userConfig?.AOPConfig?.AOPFixed ?? null,
  },
  TOPConfig: {
    TOPTable: normalizeVisibleTOPColumns(userConfig?.TOPConfig?.TOPTable ?? tasksDefaultConfiguration),
    TOPFixed: userConfig?.TOPConfig?.TOPFixed ?? null,
  },
  AODPConfig: {
    AODPTable: normalizeVisibleAODColumns(userConfig?.AODPConfig?.AODPTable ?? admissionDatabaseDefaultConfiguration),
    AODPFixed: userConfig?.AODPConfig?.AODPFixed ?? null,
  },
  OAPConfig: {
    OAPTable: normalizeVisibleOAPColumns(userConfig?.OAPConfig?.OAPTable ?? officeAccountingDefaultConfiguration),
    OAPFixed: userConfig?.OAPConfig?.OAPFixed ?? null,
  },
  SideBarConfig: {
    list: userConfig?.SideBarConfig?.list || sideBarMenuAllOptions,
  },
};

const userOptionsSlice = createSlice({
  name: "userOptions",
  initialState,
  reducers: {
    setActualUserConfig(state, action: PayloadAction<Partial<IUserOptionsConfig>>) {
      if (action.payload.AOPConfig) {
        state.AOPConfig = {
          ...state.AOPConfig,
          ...action.payload.AOPConfig,
          ...(action.payload.AOPConfig.AOPTable
            ? { AOPTable: normalizeVisibleAOPColumns(action.payload.AOPConfig.AOPTable) }
            : {}),
        };
      }
      if (action.payload.AODPConfig) {
        state.AODPConfig = {
          ...state.AODPConfig,
          ...action.payload.AODPConfig,
          ...(action.payload.AODPConfig.AODPTable
            ? { AODPTable: normalizeVisibleAODColumns(action.payload.AODPConfig.AODPTable) }
            : {}),
        };
      }
      if (action.payload.TOPConfig) {
        state.TOPConfig = {
          ...state.TOPConfig,
          ...action.payload.TOPConfig,
          ...(action.payload.TOPConfig.TOPTable
            ? { TOPTable: normalizeVisibleTOPColumns(action.payload.TOPConfig.TOPTable) }
            : {}),
        };
      }
      if (action.payload.OAPConfig) {
        state.OAPConfig = {
          ...state.OAPConfig,
          ...action.payload.OAPConfig,
          ...(action.payload.OAPConfig.OAPTable
            ? { OAPTable: normalizeVisibleOAPColumns(action.payload.OAPConfig.OAPTable) }
            : {}),
        };
      }
      if (action.payload.SideBarConfig) {
        state.SideBarConfig = {
          list: action.payload.SideBarConfig.list || state.SideBarConfig.list,
        };
      }
    },
  },
});

export const { setActualUserConfig } = userOptionsSlice.actions;

export default userOptionsSlice.reducer;
